import React, { useEffect } from 'react';
import { getAgentElement } from './mindsetAI';
import { useMindsetUploadTranscriptModalTool } from './useMindsetUploadTranscriptModalTool';
import { useMindsetManageCalendarModalTool } from './useMindsetManageCalendarModalTool';
import { useMindsetContactFormModalTool } from './useMindsetContactFormModalTool';
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function useMindsetPageTools(isInitialized, containerId) {
  var _useMindsetUploadTran = useMindsetUploadTranscriptModalTool(containerId),
    uploadTranscriptTool = _useMindsetUploadTran.tool,
    uploadTranscriptModal = _useMindsetUploadTran.modal;
  var _useMindsetManageCale = useMindsetManageCalendarModalTool(containerId),
    manageCalendarTool = _useMindsetManageCale.tool,
    manageCalendarModal = _useMindsetManageCale.modal;
  var _useMindsetContactFor = useMindsetContactFormModalTool(),
    contactFormTool = _useMindsetContactFor.tool;
  useEffect(function () {
    if (!isInitialized) return;
    var agentEl = getAgentElement(containerId);
    if (!(agentEl !== null && agentEl !== void 0 && agentEl.setPageTools)) return;
    var tools = [uploadTranscriptTool, manageCalendarTool, contactFormTool];
    function registerTools() {
      var _agentEl$setPageTools;
      agentEl === null || agentEl === void 0 || (_agentEl$setPageTools = agentEl.setPageTools) === null || _agentEl$setPageTools === void 0 || _agentEl$setPageTools.call(agentEl, tools);
    }
    agentEl.addEventListener('mindset:agent-idle', registerTools);
    return function () {
      return agentEl.removeEventListener('mindset:agent-idle', registerTools);
    };
  }, [isInitialized, containerId, uploadTranscriptTool, manageCalendarTool, contactFormTool]);
  return {
    modals: /*#__PURE__*/_jsxs(_Fragment, {
      children: [uploadTranscriptModal, manageCalendarModal]
    })
  };
}